import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import FormInput from '../../containers/shared/forms/form-input';
import { PasswordStrengthBox } from '../styled/components/password-box';
import { selectState } from '../../selectors';
import { checkPasswordStrength } from '../../lib/side-effects/check-passwords';
export const strongPasswordText = 'The strongest passwords are long and contain numbers, symbols, and a mix of upper and lower case letters';
const PasswordShowButton = styled.span `
  background: transparent;
  border: 1px solid transparent;
  border-radius: 2px;
  display: block;
  font-size: .85em;
  height: auto;
  padding: 1px 5px 2px;
  position: absolute;
  top: 4px;
  right: 4px;
  color: ${COLORS.lighterMediumDarkGray};
  &:before, &:after {
    content: "";
    display: table;
    width: 100%;
    visibility: hidden;
  }
  &:hover {
    cursor: pointer;
  }
`;
const PasswordInput = ({ marginAboveError }) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [strengthText, setStrengthText] = useState('Strength');
    const [strengthMeterClass, setStrengthMeterClass] = useState('Strength');
    const { sharedSignup: { signupForm: { password } }, } = useSelector(selectState);
    useEffect(() => {
        checkPasswordStrength({ password: password || '', setStrengthText, setStrengthMeterClass });
    }, [password]);
    return React.createElement("fieldset", null,
        React.createElement("div", { className: 'relative' },
            React.createElement(FormInput, { marginAboveError: marginAboveError, type: isPasswordVisible ? 'text' : 'password', fieldName: 'password', placeholder: 'Password' }),
            React.createElement(PasswordShowButton, { tabIndex: '0', onClick: () => setIsPasswordVisible(!isPasswordVisible), onKeyDown: (e) => {
                    if (e.which === 13) {
                        e.preventDefault();
                        setIsPasswordVisible(!isPasswordVisible);
                    }
                } }, isPasswordVisible ? 'hide' : 'show'),
            React.createElement(PasswordStrengthBox, null,
                React.createElement("div", { id: 'strength-meter-gauge', className: `${strengthMeterClass} form-inline strength-meter` }),
                React.createElement("div", { id: 'strength-text', className: `${strengthMeterClass} strength-text` }, strengthText))));
};
export default PasswordInput;
